// utils/pricing.js

/**
 * Precio unitario efectivo según la "línea de coste" del socio (estilo danimateu).
 * Defecto -> price; Segunda -> price_second_line; Tercera -> price_third_line.
 * Si la línea está vacía o es 0, cae al precio normal. Réplica de la lógica del
 * backend en make_purchase, para que el carrito muestre el mismo importe que se cobra.
 */
export function effectiveUnitPrice(product, costLine) {
  const base = Number(product?.price) || 0;
  let linePrice = null;
  if (costLine === 'Segunda') linePrice = product?.price_second_line;
  else if (costLine === 'Tercera') linePrice = product?.price_third_line;
  if (linePrice == null) return base;
  const n = Number(linePrice);
  return n > 0 ? n : base;
}

export function calculateLineTotal(price, quantity, discountTiers = []) {
    // 1) Raw total
    const raw = price * quantity;
  
    // 2) Find best discount%
    const applicable = discountTiers
      .filter(({ min_qty }) => quantity >= min_qty)
      .map(({ discount_pct }) => discount_pct);
  
    const discountPct = applicable.length
      ? Math.max(...applicable)
      : 0;
  
    // 3) Discounted total
    const total = +(raw * (1 - discountPct / 100)).toFixed(2);
  
    return { total, discountPct };
  }
  